// components/LoadProductDrawer.tsx
'use client'
import { Card } from '@/components/ui/card'
import LoadingPage from '@/src/components/LoadingPage'
import { useProductOrder } from '@/src/hooks/useProductOrder'
import useCartStore from '@/src/store/useCartStore'
import { PersianNum } from '@/src/tools'
import Image from 'next/image'
import Link from 'next/link'
import { FC } from 'react'

const LoadProductDrawer: FC = () => {
    const increase = useCartStore((s) => s.increaseCard)
    const decrease = useCartStore((s) => s.decreaseCard)
    const { data, loading } = useProductOrder()

    if (loading) return <LoadingPage />

    return (
        <div className="w-72 h-full p-4 bg-white dark:bg-slate-800 overflow-y-auto">
            {data.length ? (
                data.map((item) => {
                    const mainImage =
                        item.Albums.find((a) => a.album_main) || item.Albums[0]
                    const src = mainImage.album_image_src || item.Product.product_image
                    const alt = mainImage.album_image_alt || item.Product.product_image_alt

                    return (
                        <Card key={item.id} className="flex items-center p-2 mb-3">
                            <Link
                                href={`/product/${item.Product.product_url.replace(/ /g, "-")}`}
                                className="w-48 h-48 relative flex-shrink-0 rounded"
                            >
                                <Image
                                    src={process.env.IMAGE_URL + src}
                                    alt={alt}
                                    fill
                                    className="object-cover rounded"
                                />
                            </Link>

                            {/* Details */}
                            <div className="flex-1 mr-3 flex flex-col justify-between h-16">
                                <div>
                                    <p className="text-sm font-medium truncate">
                                        {item.Product.product_title}
                                    </p>
                                    <p className="text-xs text-gray-500 truncate">
                                        {item.property
                                            ?.map((p) => `${p.property}: ${p.attr}`)
                                            .join(', ')}
                                    </p>
                                </div>

                                <div className="flex items-center justify-between">
                                    <span className="text-sm font-semibold">
                                        {PersianNum(
                                            (item.Warehouses[0]?.warehouse_price ?? 0) * item.count
                                        )}{' '}
                                        تومان
                                    </span>

                                    <div className="flex items-center space-x-1">
                                        <button
                                            onClick={() => decrease(item.id)}
                                            className="p-1 hover:bg-gray-100 dark:hover:bg-slate-700 rounded"
                                        >
                                            -
                                        </button>
                                        <span className="w-6 text-center text-sm">
                                            {PersianNum(item.count)}
                                        </span>
                                        <button
                                            onClick={() => increase(item.id)}
                                            className="p-1 hover:bg-gray-100 dark:hover:bg-slate-700 rounded"
                                        >
                                            +
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </Card>
                    )
                })
            ) : (
                <p className="text-center text-gray-500">سبدی خالی است</p>
            )}
        </div>
    )
}

export default LoadProductDrawer
